import Service from './Service';

export default class ServiceProfile extends Service {
	public fetchPage(page: number = 0, pageSize: number = 5) {
		return this.wrapper.get(`profile?page=${page}&pageSize=${pageSize}`);
	}
	public fetch(id: number) {
		return this.wrapper.get(`profile/${id}`);
	}
}
